import { FC, PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

import Card from 'design-system/components/Card/Card';
import Header from 'design-system/components/Card/Header';
import Spacer from 'design-system/components/Spacer';

const ChildComponentsContainer = styled.div`
  padding-top: 8px;
`;
interface CollapsibleBodyProps {
  actions?: ReactNode;
  id?: string;
  isOpen?: boolean;
  onHeaderClick: () => void;
  title: ReactNode;
}
const CollapsibleBody: FC<PropsWithChildren<CollapsibleBodyProps>> = ({
  actions,
  children,
  id,
  isOpen = false,
  onHeaderClick,
  title,
}) => {
  return (
    <section>
      <div id={id} onClick={onHeaderClick}>
        <Header>{title}</Header>
      </div>
      {isOpen && (
        <ChildComponentsContainer>
          <Spacer height={1} />
          {children}
        </ChildComponentsContainer>
      )}
      <div id={`${id}_actions_containers`}>
        <Header actions={actions}>{null}</Header>
      </div>
    </section>
  );
};

const StepperTitle = styled.span<{ active: boolean }>`
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  color: ${({ theme, active }) => (active ? theme.color.text.primary : theme.color.text.secondary)};
`;

interface StepperCardProps {
  id?: string;
  title: string;
  children: React.ReactNode;
  active: boolean;
  actions?: React.ReactNode;
  onClick: () => void;
}

const StepperCard = ({ actions, children, active, onClick, id, title }: StepperCardProps) => {
  return (
    <Card
      onClick={() => {
        if (!active) {
          onClick();
        }
      }}
    >
      <Card.Body>
        <CollapsibleBody
          id={id}
          isOpen={active}
          title={<StepperTitle active={active}>{title}</StepperTitle>}
          actions={actions}
          onHeaderClick={onClick}
        >
          {children}
        </CollapsibleBody>
      </Card.Body>
    </Card>
  );
};

export default StepperCard;
